import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "../organisms/Sidebar.tsx";
import { TopBar } from "../organisms/TopBar.tsx";
import { CommandPalette } from "../organisms/CommandPalette.tsx";
import { titleForPath } from "../../lib/nav.ts";

export function DashboardLayout() {
  const { pathname } = useLocation();
  const title = titleForPath(pathname);
  return (
    <div className="layout">
      <CommandPalette />
      <Sidebar />
      <div className="main">
        <TopBar title={title} />
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
